import { route } from "@circle-react/lib/routes/define";

export const eventRoutes = {
  all: route("/events", {
    title: "All events",
    requires: "member",
    description:
      "Member-facing All Events page (the events directory) for the community. Use this for queries like 'all events', 'events directory', or 'upcoming events page' when no specific space is named — members browse and RSVP to upcoming and past events across every event-type space here. URL is exactly /events (no path segments or query params). This is the member browsing view — NOT the admin event analytics page at /settings/analytics/events.",
  }),

  detail: route("/c/:spaceSlug/:eventSlug", {
    title: "Event detail",
    requires: "member",
    description:
      "Member-facing detail page for a single event in an event-type space. Shows event info, date and time, location or live link, and the RSVP / attend action. This is the member view — not the admin event-management screen.",
    pathParams: {
      spaceSlug: {
        type: "string",
        description: "Slug of the event-type space containing the event.",
      },
      eventSlug: {
        type: "string",
        description: "Slug of the event.",
      },
    },
  }),

  list: route("/c/:spaceSlug", {
    title: "Events list",
    requires: "member",
    description:
      "Member-facing events list for a specific event-type space. URL format: /c/:spaceSlug — always keep the /c/ prefix and substitute the space slug. Tab selection uses query params only (never path segments like /upcoming or /past). Upcoming (DEFAULT): no tab params; optionally ?sort=asc. Past events tab: ?pastEvents=true&sort=desc — NEVER use status=past. Draft events tab: ?status=draft&sort=asc. The status param is ONLY for the drafts tab (value 'draft') — NOT for past or upcoming. This is the member view — not the admin events settings.",
    pathParams: {
      spaceSlug: {
        type: "string",
        description: "Slug of the event-type space.",
      },
    },
    queryParams: {
      pastEvents: {
        type: "boolean",
        description:
          "Past events tab. Set to true and also include sort=desc, e.g. ?pastEvents=true&sort=desc. Do NOT use status=past.",
      },
      status: {
        type: "string",
        description:
          "Draft events tab only. Accepted value: 'draft'. NEVER use 'past' or 'upcoming' — past events use pastEvents=true instead.",
      },
      sort: {
        type: "string",
        description:
          "Sort order. Use 'asc' for upcoming/drafts, 'desc' for past events (required with pastEvents=true).",
      },
    },
  }),
};
